import React from 'react';
import { FormattedMessage } from 'react-intl';
import LoadingIndicator from './indicator';
var staticIndicator = React.createElement(LoadingIndicator, {
  global: true
}, React.createElement(FormattedMessage, {
  id: 'loadingIndicator.message',
  defaultMessage: 'Fetching Data...'
}));
export default staticIndicator;